'use client'

import React, { useEffect } from 'react'
import styles from '../../styles/Components/Shared/Modal.module.css'
// ICONS
import { IoClose } from "react-icons/io5";

const Modal  = ({open, setOpen, component, clearState, addedStyles={}, disableClickToClose, allowClickToClose, reloadOnClose, isSubModal, transparentBackground }) => {  
    useEffect(() => {
        if (isSubModal) {
            return
        }
        
        if (open) {
            document.body.style.overflowY = 'hidden'
        } else {
            document.body.style.overflowY = 'unset'
        }

        return () => document.body.style.overflowY = 'unset'
    }, [open, isSubModal])

    const handleClose = (e) => {
        if (e !== 'close' && !allowClickToClose) { 
            return
        }

        if ((!disableClickToClose && e?.target?.className?.length > 0 && e?.target?.className?.includes && ((e?.target?.className?.includes('modal_container')) || e?.target?.className?.includes('modal_wrapper')))  || e === 'close') {
            setOpen(false);

            if (!isSubModal) {
                document.body.style.overflowY = 'unset'
            }
            
            if (clearState) {
                clearState();
            }

            if (reloadOnClose) {
                reloadOnClose()
            }
        }
    }
    
    
    return  (
        open && component?
            <div className={`${styles.modal_wrapper} ${open ? styles.open : ''}`} onClick={(e)=>handleClose(e)}>
                <div className={`${styles.modal_container} ${open ? styles.open : ''}`}>
                    <div className={`${styles.modal_content} ${transparentBackground ? styles.modal_transparent_background : ''}`} style={{...addedStyles}}>
                        {component}
                        
                        <p className={`${styles.modal_close_button} ${transparentBackground ? styles.modal_transparent_background_close : ''}`} onClick={()=>handleClose('close')}><IoClose  size={30}/></p>
                    </div>
                </div>
            </div>
        : null
    )
}
export default Modal;